import { StylesProvider } from "@material-ui/core/styles";
import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import "./styles/masterStyles.css";
import { TestSearchScreen } from "./screens/TestSearchScreen";

//TODO change question screen to protected route CoreVideoListScreen

class Routes extends React.Component {
    componentDidMount = async () => {
        
    }

    render() {
        // console.log('\n\nSTARTING Routes....');
        // console.log("router props: ", this.props);
        return (
            <StylesProvider injectFirst>
                <Router>
                    <Switch> 
                        {/* <Route exact path="/" component={TestSearchScreen} /> */}
                        <Route path="*" component={TestSearchScreen} />
                    </Switch>
                </Router>
            </StylesProvider>
        );
    }
}

export default Routes;